import FormattedAddress from "components/Atoms/FormattedAddress";
import { CompanySidePanel, PromoterSidePanel } from "components/SidePanel/Company/CompanySidePanel";
import React from "react";

interface Props {
  company: server.dto.CompanySmall
  displayAs: "promoter" | "hotel"
  displayTooltip: boolean
}

const renderPreview = (props: Props) => {
  switch (props.displayAs) {
    case "promoter":
      return <PromoterSidePanel
        companyId={props.company.companyId}
        trigger={<a>{props.company.name}</a>}
        fallbackIfNoPermission={<strong>{props.company.name}</strong>}
      />;
    case "hotel":
      return <CompanySidePanel
        companyId={props.company.companyId}
        trigger={<a>{props.company.name}</a>}
        fallbackIfNoPermission={<strong>{props.company.name}</strong>}
      />;
  }
};

const ReadonlyCompany = (props: Props) => {
  return <div className="flex gap" style={{ flex: 1 }}>
    <div>
      <div>
        {props.displayTooltip && renderPreview(props)}
        {!props.displayTooltip && <strong>{props.company.name}</strong>}
      </div>
      <FormattedAddress address={props.company.address} />
    </div>
  </div>;
};

export default ReadonlyCompany;
